<template>
    <div class="home_wrap">
        <div>
            <van-nav-bar :title="title" left-text="" left-arrow :fixed="true" @click-left="onClickLeft">
                <template #right>
                    <div class="hisBtn" @click="toHistory(4)">Histórico</div>
                </template>
            </van-nav-bar>
        </div>
        <div class="big-box">
            <div class="main-box">
                <div class="main-title">
                    <div>Valor da sorte atual <span>{{ goTimes }}</span></div>
                    <div>Durante a atividade já apostou {{ textInfo.today_bet_amount }}, ainda precisa apostar {{
                        textInfo.need_bet_amount }} para ter 1 chance na roleta!
                    </div>
                </div>
                <div class="main-game">
                    <div class="container">
                        <img src="../../assets/images/Turntable/Turntable.png" alt="">
                        <div class="prizeList" ref="turntable">
                            <div class="prizeItem" v-for="(item, index) in prizeList" :key="item.id"
                                :style="'transform:rotate(' + index * 36 + 'deg)'">
                                <p>{{ item.name }}</p>
                            </div>
                        </div>
                        <div class="prizeList-btn" @click="spin">
                            <span>Sorteio de roleta</span>
                            <img src="../../assets/images/Turntable/turnTableBtn.png" alt="">
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <div class="btnItem">
                            <div>Sorteio de roleta</div>
                            <div class="num"><span>{{ info.need }}</span> Pontos de Sorte</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rightInfoBox">
                <div class="tab-head">
                    <van-tabs v-model="active" class="van-tabs__wrap--scrollable" animated offset-top="1.2rem"
                        lazy-render @change="tabChange">
                        <van-tab title="Notificação de Prêmio" />
                        <van-tab title="Meus Registros" />
                    </van-tabs>
                </div>
                <div class="tab-content" v-if="active == 0">
                    <div class="tab-list-empty-text" v-if="recordList.length == 0">Sem Registros</div>
                    <div class="tab-list" v-else>
                        <ul class="tab-list-items">
                            <li class="tab-list-item" v-show="index < step_show" v-for="(item, index) in recordList">
                                <div class="list-left">
                                    <img src="https://img2.thethsdnadagvx.com/gjlm297/c1e3e0dc-bb07-4f12-af7e-80931d663705.png"
                                        alt="">
                                    <div class="winListName">
                                        <p>{{ item.createtime }}</p>
                                        <p>{{ item.memo }}</p>
                                    </div>
                                </div>
                                <p class="list-right">{{ item.money }}</p>
                            </li>
                            <div class="show_more" v-show="recordList.length > step_show" @click="showMore()">
                                <div>
                                    A exibir {{ step_show }} jogos entre
                                    {{ recordList.length }} Popular jogos
                                </div>
                                Mostre mais ⇊
                            </div>
                        </ul>
                    </div>
                </div>
                <div class="tab-content" v-if="active == 1">
                    <div class="tab-list-empty-text" v-if="recordList.length == 0">Sem Registros</div>
                    <div class="tab-list" v-else>
                        <ul class="tab-list-items">
                            <li class="tab-list-item" v-show="index < step_show" v-for="(item, index) in recordList">
                                <div class="list-left">
                                    <img src="https://img2.thethsdnadagvx.com/gjlm297/c1e3e0dc-bb07-4f12-af7e-80931d663705.png"
                                        alt="">
                                    <div class="winListName">
                                        <p>{{ item.createtime }}</p>
                                        <p>{{ item.memo }}</p>
                                    </div>
                                </div>
                                <p class="list-right">{{ item.money }}</p>
                            </li>
                            <div class="show_more" v-show="recordList.length > step_show" @click="showMore()">
                                <div>
                                    A exibir {{ step_show }} jogos entre
                                    {{ recordList.length }} Popular jogos
                                </div>
                                Mostre mais ⇊
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="turntableRules">
                <p>
                    Você pode ter uma chance apostando todos os dias. Quanto mais você apostar, mais bônus
                    receberá.
                </p>
            </div>
        </div>
        <ft></ft>
    </div>
</template>
<script>
import Vue from "vue";
import ft from "../../components/ft.vue";
import Fetch from "../../utils/fetch";
import {
    NavBar,
    Tab,
    Tabs,
} from "vant";
Vue.use(NavBar).use(Tab).use(Tabs);

export default {
    name: "turnTable",
    components: {
        ft,
    },
    data() {
        return {
            title: "Roleta",
            prizeList: [
            ],
            info: {},
            isGo: false,
            isGo: false,//是否正在执行动画
            oTurntable: '',//执行动画的对象
            randomDeg: 0,//即将旋转的度数   
            lastDeg: 0,//上一次旋转的度数
            goTimes: 5,//抽奖次数
            active: 0,
            recordList: [],
            targetId: 0,
            fullRotation: 360,
            step_show: 10,
            textInfo: {},
        }
    },
    created() {

    },
    computed: {
        // rotationAngle() {
        //     debugger
        //     const itemIndex = this.prizeList.findIndex(item => item.id === this.targetId);
        //     if (this.targetId == 0) {
        //         return 0
        //     } else {
        //         const anglePerItem = this.fullRotation / this.prizeList.length;
        //         return anglePerItem * itemIndex - this.fullRotation / 2;
        //     }
        // }
    },
    mounted() {
        this.oTurntable = this.$refs.turntable
        this.turnTableInit();
    },
    methods: {
        onClickLeft() {
            this.$router.push("/");
        },
        tabChange(v) {
            this.active = v;
            this.step_show = 10;
            Fetch("/turntable/record", {
                flag: this.active
            }).then((r) => {
                // console.log(r);
                this.recordList = r.data.record;
            });
        },
        showMore(idx) {
            this.step_show += 10;
        },
        toHistory(v) {
            this.$router.push({ name: "activity", query: { tab: v } });
        },
        spin() {
            console.log("转动转盘")
            if (!this.isGo && this.goTimes > 0) {
                Fetch("/turntable/turn").then((r) => {
                    if (r.code == 0) {
                        this.$message({
                            message: r.msg,
                            type: "error",
                        });
                    } else {
                        this.getNumber(r.data.turntable.id);
                    }
                })
                // this.getNumber();
            }
            else if (!this.isGo && this.goTimes <= 0) {
                this.$message({
                    message: "Seus sorteios foram esgotados!",
                    type: "error",
                });
            }
            else return
        },
        turnTableInit() {
            Fetch("/turntable/init").then((r) => {
                // console.log(r)
                this.prizeList = r.data.list;
                this.info = r.data.button.silver;
                this.goTimes = r.data.num;
                this.textInfo = r.data;
            });
            Fetch("/turntable/record", {
                flag: this.active
            }).then((r) => {
                // console.log(r);
                this.recordList = r.data.record;
            });
        },

        getNumber(num) {
            let caseNum = "";
            if (num == 10) {
                caseNum = 1
            } else if (num == 9) {
                caseNum = 2
            } else if (num == 8) {
                caseNum = 3
            } else if (num == 7) {
                caseNum = 4
            } else if (num == 6) {
                caseNum = 5
            } else if (num == 5) {
                caseNum = 6
            } else if (num == 4) {
                caseNum = 7
            } else if (num == 3) {
                caseNum = 8
            } else if (num == 1) {
                caseNum = 0
            } else if (num == 2) {
                caseNum = 9
            }
            switch (caseNum) {
                case 0:
                    this.ratating(0, "1");
                    break;
                case 1:
                    this.ratating((360 / 10) * 1, "177");
                    break;
                case 2:
                    this.ratating((360 / 10) * 2, "77");
                    break;
                case 3:
                    this.ratating((360 / 10) * 3, "57");
                    break;
                case 4:
                    this.ratating((360 / 10) * 4, "37");
                    break;
                case 5:
                    this.ratating((360 / 10) * 5, "17");
                    break;
                case 6:
                    this.ratating((360 / 10) * 6, "7");
                    break;
                case 7:
                    this.ratating((360 / 10) * 7, "3");
                    break;
                case 8:
                    this.ratating((360 / 10) * 8, "2");
                    break;
                case 9:
                    this.ratating((360 / 10) * 9, "1");
                    break;
            }
        },
        getRandom(n, m) {             //该方法产生[n,m]之间随机数
            let result = Math.floor(Math.floor(Math.random() * (m - n + 1) + n))
            return result;
        },
        ratating(deg, text) {
            this.goTimes--
            this.isGo = true
            let times = this.getRandom(3, 6)//圈数(从用户体验角度考虑，设计随机转3-6圈。最少3圈，最多6圈)

            this.randomDeg = deg + 360 * times      //记录这次要旋转的度数(传来的度数+圈数)
            let realDeg = (360 - this.lastDeg % 360) + this.lastDeg + this.randomDeg
            /*上次指针离初始状态的度数 + 上次的度数 + 这次要旋转的度数
            (这样的目的是为了每次旋转都从原点开始，保证数据准确)*/
            this.oTurntable.style.transform = `rotate(${realDeg}deg)`;
            setTimeout(() => {
                this.isGo = false
                Fetch("/turntable/record", {
                    flag: this.active
                }).then((r) => {
                    // console.log(r);
                    this.recordList = r.data.record;
                });
                console.log(`以原点为基准共旋转了${this.randomDeg}度,
        			以一圈为基准相对旋转了${this.randomDeg % 360}度,最终结果为${text}`)
                this.lastDeg = realDeg    //把这次度数存储起来，方便下一次获取
            }, 4000)                     //4000ms为css里面写的执行动画的时间
        },
    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

.home_wrap {
    width: 100%;
    min-height: 100vh;
    background-color: @activityColor;
    padding-top: 1.2rem;
    // padding-bottom: 1.2rem;
}

/deep/ .van-nav-bar {
    background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
    color: #fff;
}

/deep/ .van-nav-bar__title {
    color: #fff;
    font-size: .38rem;
}

/deep/.van-tab__text {
    font-size: 0.32rem;
    color: #fff;
}

/deep/.van-tabs__line {
    background: @ButtonColor;
    height: 0.04rem;
    width: 35%;
}

/deep/ .van-tabs__nav {
    padding-left: 0;
    padding-right: 0;
    background-color: @secondary-color;
}

/deep/ .van-tab--active .van-tab__text {
    color: @rechargeColor;
}

.hisBtn {
    color: @ButtonColor;
    font-size: .32rem;
}

.num span {
    color: #fff !important;
}

.show_more {
    color: @anttextcolor;
    width: 95%;
    margin: 0 auto;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 0.35rem;

    div {
        height: 0.5rem;
        line-height: 0.5rem;
        color: @textcolor3;
    }
}

.big-box {
    width: 100%;
    // text-align: center;
    // display: flex;
    // justify-items: center;

    .main-box {
        box-sizing: border-box;
        width: 95%;
        background-color: @secondary-color;
        border-radius: .14rem;
        padding: .2rem;
        margin: 0 auto;
        margin-top: .2rem;

        .main-title {
            border-bottom: 0.01rem solid @bodercolor;
            padding-bottom: .2rem;

            div {
                color: @textcolor1;
                font-size: .32rem;
                line-height: .5rem;

                span {
                    color: @textcolor4;
                }
            }
        }

        .main-game {
            .container {
                position: relative;
                width: 6.7rem;
                height: 6.7rem;
                margin: 0 auto;
                margin-bottom: .24rem;
                margin-top: 1rem;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                }

                .prizeList {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background-repeat: no-repeat;
                    background-position: 50%;
                    background-size: contain;
                    overflow: hidden;
                    transition: all 4s;

                    .prizeItem {
                        position: absolute;
                        top: -50%;
                        width: 100%;
                        height: 100%;
                        text-align: center;
                        transform-origin: center bottom;

                        p {
                            position: absolute;
                            width: 100%;
                            bottom: 33%;
                            left: 0;
                            font-size: .36rem;
                            color: #fff;
                        }
                    }
                }

                .prizeList-btn {
                    position: absolute;
                    bottom: 50%;
                    left: 50%;
                    transform: translate(-50%, 25%);
                    text-align: center;
                    cursor: pointer;
                    width: 4.3rem;
                    height: 4.923rem;

                    span {
                        position: absolute;
                        transform: translate(-50%, -50%);
                        bottom: -12%;
                        left: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: .33rem;
                        font-weight: 700;
                        color: #fff;
                        line-height: normal;
                        width: 1.72rem;
                        height: 1.72rem;
                        text-wrap: balance;
                        z-index: 9;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .bottom-btn {
                // padding: .2rem;
                display: flex;

                .btnItem {
                    padding: .3rem;
                    background-color: #9778ff;
                    font-size: .3rem;
                    border-radius: .2rem;
                    color: #fff;
                    text-align: center;

                    .num {
                        font-size: .2rem;
                    }
                }

            }
        }
    }

    .rightInfoBox {
        box-sizing: border-box;
        width: 95%;
        background-color: @secondary-color;
        border-radius: .14rem;
        padding: .2rem;
        margin: 0 auto;
        margin-top: .2rem;

        .tab-head {
            border-bottom: 0.01rem solid @bodercolor;
        }

        .tab-content {
            .tab-list {
                .tab-list-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-left: .2rem;
                    border-bottom: 0.01rem solid @bodercolor;
                    padding-bottom: .1rem;

                    // padding: .24rem;
                    .list-left {
                        display: flex;
                        align-items: center;
                        gap: .2rem;

                        .winListName {
                            display: flex;
                            gap: .4rem;

                            p {
                                color: @textcolor1;
                                font-size: .3rem;
                                // margin-left: .2rem;
                            }
                        }

                        img {
                            width: 0.6rem;
                            height: .6rem;
                        }
                    }

                    .list-right {
                        font-size: .3rem;
                        color: @textcolor4;
                    }
                }

                .tab-list-item:last-child {
                    border-bottom: none;
                    margin-bottom: .1rem;
                }
            }

            .tab-list-empty-text {
                padding: 16px;
                color: #fff;
                font-size: 14px;
                text-align: center;
            }
        }
    }

    .turntableRules {
        box-sizing: border-box;
        width: 95%;
        background-color: @secondary-color;
        border-radius: .14rem;
        padding: .34rem;
        margin: 0 auto;
        margin-top: .2rem;
        box-shadow: 0 -.003rem 0 .01rem rgba(0, 0, 0, .1);

        p {
            color: @textcolor1;
            font-weight: 700;
        }
    }
}

.svg_icon {
    fill: #fff;
    margin-left: 1rem;
}
</style>